module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab151-a9a5ff3e3727c882544e453030612ed5.jpg";